// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__36exM","info":"UpdateTermsInfo_info__3EVkW"};